import { FormControl, styled as MUIStyled, Typography } from '@mui/material';
import { Field } from 'formik';

export const CMField = MUIStyled(Field)(({theme, readOnly}) => ({
    height: '29px',
    padding: (readOnly) ? "0" : "0 1rem",
    margin: '0.5em 0',
    borderRadius: '4px',
    border: `1px solid #E0E0E0`,

    "&:focus, &:focus-visible": {
        outline: 'unset',
    },

    "&.error": {
        border: `1px solid #f4e0e0`
    }
}));

export const CMErrorMessage = MUIStyled(Typography)(({theme}) => ({
    color: `#a80000`,
    "@media(min-width: 2000px)": {
        fontSize: "1.5vh",
        top:"-2vh !important"
    },

}));

export const CMSuccessMessage = MUIStyled(Typography)(({theme}) => ({
    color: `#0c8500`,
    fontWeight: 800
}));

export const CMFormControl = MUIStyled(FormControl)`
    margin: 8px 0;
    @media (max-width: 768px) {
        width: 100%;
    }
`;